import AmioHttpService from './amio-http.service'

class AnswerService extends AmioHttpService {

  create(botId, name, conversationJson) {
    const data = { name }
    if (conversationJson) data.conversation_json = conversationJson

    return this.requestPost(`/bots/${botId}/answers`, data)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  update(botId, answerId, patch) {
    return this.requestPatch(`/bots/${botId}/answers/${answerId}`, patch)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  get(botId, answerId) {
    return this.requestGet(`/bots/${botId}/answers/${answerId}`)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  list(botId) {
    return this.requestGet(`/bots/${botId}/answers`)
      .then(response => response.data)
      .then(answers => answers.map(adapt))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  listAnswerVariants(botId, answerId) {
    return this.requestGet(`/bots/${botId}/answers/${answerId}/variants`)
      .then(response => response.data)
      .then(variants => variants.map(adapt))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  getReferences(botId, answerId) {
    return this.requestGet(`/bots/${botId}/answers/${answerId}/references`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  getReferencedConversations(botId, answerId) {
    return this.requestGet(`/bots/${botId}/answers/${answerId}/referenced-conversations`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  delete(botId, answerId) {
    return this.requestDelete(`/bots/${botId}/answers/${answerId}`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

function adapt(answer) {
  const adaptedAnswer = {
    id: answer.id,
    botId: answer.bot_id,
    intent: {
      id: answer.intent.id,
      platformId: answer.intent.platform_id,
      description: answer.intent.description,
      example: answer.intent.example,
      examplesCount: answer.intent.examples_count,
      exampleId: answer.intent.example_id
    },
    name: answer.name,
    published: answer.published,
    requestOutcome: {
      id: answer.request_outcome.id,
      name: answer.request_outcome.name
    },
    conversationId: answer.conversation_id,
    inheritsConversation: answer.inherits_conversation,
    multiBotItemId: answer.multi_bot_item_id,
    conversationSource: answer.conversation_source
  }

  if (answer.conversation_json) {
    adaptedAnswer.conversationJson = answer.conversation_json
    adaptedAnswer.conversationJsonHash = answer.conversation_json_hash
  }

  if (answer.variable_warnings) adaptedAnswer.variableWarnings = answer.variable_warnings

  return adaptedAnswer
}

export default new AnswerService()
